import { render, staticRenderFns } from "./stopwordDialog.vue?vue&type=template&id=5a033e44&scoped=true"
import script from "./stopwordDialog.vue?vue&type=script&lang=js"
export * from "./stopwordDialog.vue?vue&type=script&lang=js"
import style0 from "./stopwordDialog.vue?vue&type=style&index=0&id=5a033e44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a033e44",
  null
  
)

export default component.exports